import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6229ed56&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=6229ed56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6229ed56",
  null
  
)

export default component.exports